import AsyncSelectComponent from '@components/inputs/asyncSelect/AsyncSelect.component';
import NumberTextFieldComponent from '@components/inputs/numberTextField/NumberTextField.component';
import SelectComponent, { SelectItem } from '@components/inputs/select/Select.component';
import TextFieldComponent from '@components/inputs/textField/TextField.component';
import { Sizes } from '@constants/sizes.constants';
import { Stack, Typography } from '@mui/material';
import { AuditOperationTypeEnum, CreateAuditOperation } from '@store/audits/audits-operation/audits-operation.model';
import { UnitOfMeasure } from '@store/settings/serviceKinds';
import { wasteFamiliesService } from '@store/settings/wasteFamilies';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { map } from 'rxjs';

interface AuditContainerProps {
    isPreco?: boolean;
    auditOperation?: CreateAuditOperation;
    updateAuditOperation: <T extends keyof CreateAuditOperation>(
        field: T,
        value: CreateAuditOperation[T]
    ) => void;
    errors: any;
}


const WasteInformations = (props: AuditContainerProps) => {

    const {
        auditOperation,
        updateAuditOperation,
        errors,
    } = props;

    const [waste, setWaste] = useState<SelectItem>({ label: auditOperation?.waste?.name ?? '', value: auditOperation?.wasteId ?? '' });

    useEffect(() => {
        if (auditOperation?.waste) {
            setWaste({ label: auditOperation?.waste.name, value: auditOperation?.wasteId });
            updateAuditOperation('wasteUnit', auditOperation?.wasteUnitName);
            updateAuditOperation('annualEstimatedWeightInTons', auditOperation?.annualEstimatedWeightInTons);

        }
    }, [auditOperation?.waste, auditOperation?.annualEstimatedWeightInTons, auditOperation?.wasteId, auditOperation?.wasteUnitName, updateAuditOperation]);

    function handleWaste(waste: any) {
        updateAuditOperation('wasteId', waste?.value);
        setWaste(waste);
    }

    const { t } = useTranslation();

    return (
        <>
            <Stack direction="row" mt="3px" alignItems="center" spacing={0.5}>
                <Typography fontSize={20} fontWeight="700">
                    {t('audits.audit.waste.informations')}
                </Typography>
            </Stack>
            <Stack py="24px" pr="10px" spacing={1.5}>
                {auditOperation?.type === AuditOperationTypeEnum.CLASSIC ?
                    <AsyncSelectComponent
                        labelWidth={Sizes.drawerInputLabelWidth}
                        label={t('audits.audit.waste.name')}
                        placeholder={t('global.select')}
                        getOptions={() => wasteFamiliesService.getAllWaste().pipe(
                            map((options) => options.data.map((o) => ({ label: o.name || '-', value: o.id }))))}
                        value={waste}
                        handleChange={handleWaste}
                        error={errors.waste}
                        required={true}
                    />
                    :
                    <TextFieldComponent
                        color="primary"
                        labelWidth={Sizes.drawerInputLabelWidth}
                        placeholder={t('audits.audit.waste.name')}
                        label={t('audits.audit.waste.name')}
                        handleChange={(value) => updateAuditOperation('wasteCustom', value)}
                        value={auditOperation?.wasteCustom ?? ''}
                        error={errors.waste}
                        required={true}
                    />
                }
            </Stack>
            <Stack direction="row" mt="3px" alignItems="center" spacing={0.5}>
                <Typography fontSize={20} fontWeight="700">
                    {t('audits.audit.waste.volume')}
                </Typography>
            </Stack>
            <Stack py="24px" pr="10px" spacing={1.5}>
                <NumberTextFieldComponent
                    color="primary"
                    labelWidth={Sizes.drawerInputLabelWidth}
                    label={t('audits.audit.waste.quantity')}
                    placeholder={t('audits.audit.waste.quantity')}
                    handleChange={(value) => updateAuditOperation('annualEstimatedWeightInTons', value)}
                    value={auditOperation?.annualEstimatedWeightInTons}
                />
                <SelectComponent
                    color="primary"
                    labelWidth={Sizes.drawerInputLabelWidth}
                    label={t('audits.audit.waste.unit')}
                    placeholder={t('global.select')}
                    items={UnitOfMeasure.selectItems()}
                    handleChange={(value) => updateAuditOperation('wasteUnit', value)}
                    value={auditOperation?.wasteUnit ?? ''}
                />
            </Stack>
        </>
    );
};

export default WasteInformations;
